import SurveysHomePage from "./SurveysHomePage";

export default SurveysHomePage;
